import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/signin",
      name: "signin",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/Signin.vue")
    },
    {
      path: "/signout",
      name: "signout",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/Signout.vue"),
      meta: {
        protected: true
      }
    },
    {
      path: "/message",
      name: "message",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/Message.vue"),
      meta: {
        protected: true
      }
    },
    {
      path: "/shortlist/:id",
      name: "shortlist",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/ShortList.vue"),
      meta: {
        protected: true
      }
    },
    {
      path: "/orders-website",
      name: "orders-website",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("@/views/OrderWebsite.vue"),
      meta: {
        protected: true
      }
    },
    {
      path: "/order-website-details/",
      name: "order-website-details",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/OrderWebsiteDetails.vue"),
      meta: {
        protected: true
      }
    },
    {
      path: "/orders-ecommerce",
      name: "orders-ecommerce",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/OrderEcommerce.vue"),
      meta: {
        protected: true
      }
    },
    {
      path: "/order-ecommerce-details/",
      name: "order-ecommerce-details",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/OrderEcommerceDetails.vue"),
      meta: {
        protected: true
      }
    },
    {
      path: "/orders-software",
      name: "orders-software",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/OrderSoftware.vue"),
      meta: {
        protected: true
      }
    },
    {
      path: "/orders-services",
      name: "orders-services",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/OrderServices.vue"),
      meta: {
        protected: true
      }
    },
    {
      path: "/order-services-details/",
      name: "order-services-details",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/OrderServicesDetails.vue"),
      meta: {
        protected: true
      }
    },
    {
      path: "/explore-websites/",
      name: "explore-websites",
      props: true,
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/ExploreWebsites.vue")
    },
    {
      path: "/explore-static-websites/",
      name: "explore-static-websites",
      props: true,
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/ExploreStaticWebsites.vue")
    },
    {
      path: "/web-template-details/",
      name: "web-template-details",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/WebTemplateDetails.vue")
    },

    {
      path: "/websiteform/",
      name: "websiteform",
      props: true,
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/WebsiteForm.vue"),
      meta: {
        protected: true
      }
    },
    {
      path: "/explore-ecommerce",
      name: "explore-ecommerce",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/ExploreEcommerce.vue")
    },
    {
      path: "/ecommerce-template-details",
      name: "ecommerce-template-details",
      props: true,
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/EcommerceTemplateDetails.vue")
    },
    {
      path: "/ecommerceform/",
      name: "ecommerceform",
      props: true,
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/EcommerceForm.vue"),
      meta: {
        protected: true
      }
    },
    {
      path: "/explore-software",
      name: "explore-software",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/ExploreSoftware.vue")
    },
    {
      path: "/explore-services",
      name: "explore-services",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/ExploreServices.vue")
    },
    {
      path: "/service-template-details/",
      name: "service-template-details",
      props: true,
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/ServiceTemplateDetails.vue")
    },
    {
      path: "/serviceform/",
      name: "serviceform",
      props: true,
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/ServiceForm.vue"),
      meta: {
        protected: true
      }
    },
    {
      path: "/profile",
      name: "Profile",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/Profile.vue"),
      meta: {
        protected: true
      }
    },
    {
      path: "/billing",
      name: "Billing",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/Billing.vue"),
      meta: {
        protected: true
      }
    },
    {
      path: "/referral",
      name: "referral",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/Referral.vue"),
      meta: {
        protected: true
      }
    },
    {
      path: "/aboutus",
      name: "aboutus",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/AboutUs.vue")
    },
    {
      path: "/help",
      name: "help",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/Help.vue")
    },
    {
      path: "/contactus",
      name: "contactus",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/ContactUs.vue")
    },
    {
      path: "/privacypolicy",
      name: "PrivacyPolicy",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/PrivacyPolicy.vue")
    },
    {
      path: "/termsandconditions",
      name: "TermsandConditions",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/TermsandConditions.vue")
    },
    {
      path: "/refundpolicy",
      name: "RefundPolicy",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/RefundPolicy.vue")
    },
    {
      path: "*",
      name: "*",
      component: Home
    }
  ]
});
